import { combineReducers } from 'redux'
import login from './login'
import { services } from '../api' 
import startup from './startup'
import homePage from './homePage'
import i18n from './i18n'
import formDialog from './formDialog'
import inboundNumbers from './inboundNumbers'

export default combineReducers({
	accounts: services.accounts.reducer,
	login, 
	startup,
	i18n,
	homePage,
	formDialog,
	inboundNumbers
})



// WEBPACK FOOTER //
// ./src/reducers/index.js